import { Box, Button, ButtonProps, styled, Typography } from "@mui/material";
import React from "react";
import variables from "../../../../assets/styles/variables.module.scss";
import AutorenewIcon from "@mui/icons-material/Autorenew";

const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
  // borderRadius: "8px",
  color: variables.whiteColor,
  backgroundColor: variables.primaryButton,
  "&:hover": {
    backgroundColor: variables.primaryColor,
  },
}));

const SummaryCard = () => {
  return (
    <Box
      sx={{
        border: `solid 1px ${variables.borderColor}`,
        p: 3,
        borderRadius: "15px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 6,
      }}
    >
      <Typography>Files Summary</Typography>
      <Box
        sx={{
            display:"flex",
            flexDirection:"column",
            gap:2,
        }}
      >
        <Typography
          sx={{
            textAlign: "center",
          }}
        >
          1 File Trained (1024 chars)
        </Typography>
        <Box>
        <Typography
          sx={{
            textAlign: "center",
            fontWeight:"700",
          }}
        >
          Total detected characters 
        </Typography>
        <Typography
          sx={{
            textAlign: "center",
          }}
        >
          <span style={{ color: variables.secondaryColor }}>22,753</span> / 11,000,000 limit
        </Typography>
        </Box>
      </Box>
      <ColorButton
        variant="contained"
        disableElevation
        startIcon={<AutorenewIcon />}
        //size={isSmallScreen ? "small" : "large"}
        sx={{
          textTransform: "capitalize",
          fontWeight: "400",
          whiteSpace: "nowrap",
          borderRadius: { sm: "8px", xs: "4px" },
        }}
        //onClick={() => handleClickOpen()}
      >
        Retrain Agent
      </ColorButton>
    </Box>
  );
};

export default SummaryCard;
